module.exports = __webpack_public_path__ + "img/wiom_succ.png";